import React from 'react';
import { Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';


const ShopOfferItem = (props) => {
  let price = '';
  if (props.discount){
    price = <>
      <span className="card-price__without-discount mr-2">{ props.price_format }</span>
      <span className="card-price__with-discount">{ props.discount_price }</span>
    </>;
  } else {
    price = props.price_format;
  }

  let author = <span>{ gettext('Автор') }: <a href={ props.author_url } className={ 'cabinet-link__orange' }>{ props.author }</a></span>;
  if (props.is_arrangement){
    if (!props.author_music){
      author = <span>{ gettext('Переложение') }: <a href={ props.author_url } className={ 'cabinet-link__orange' }>{ props.author }</a></span>;
    } else {
      author = '';
    }
  }

  let cp = '';
  if (props.composer){
    cp = <span>{ gettext('Композитор') }: <a href={ props.composer_url } className={ 'cabinet-link__orange' }>{ props.composer_name }</a></span>;
  } else if (props.composer){
    cp = <span>{ gettext('Исполнитель') }: <a href={ props.performer_url } className={ 'cabinet-link__orange' }>{ props.performer_name }</a></span>;
  }

  return <div className='card mb-3'>
    <div className="row no-gutters">
      <div className="col-md-2">
        <div className='text-center'>
          { !props.checked && <Badge variant='danger' className='mb-1'>{ gettext('На модерации') }</Badge> }
          { props.imageBlock }
        </div>
      </div>
      <div className="col-md-10">
        <div className="card-body">
          <div className={'d-flex'}>
            <h6 className="card-title d-flex flex-grow-1">
              { props.checkboxBlock }
              { props.type_icon ? <i className={ 'mr-1 icon ' + props.type_icon } title={ props.type_name }></i> : '' }
              <a href={ props.url } title={ gettext('Перейти на страницу товара') }>{ props.title }</a>
            </h6>
            { props.topRightAngleMenu }
          </div>
          <div className="card-text my-1 small cabinet-card-info">
              { author }
              { cp }
              <span>{ gettext('Сложность') }: { props.difficulty_display }</span>
              { props.tonality_display && <span>{ props.tonality_display }</span> }
            {/*, { props.date_format }*/}
            {/*<span>*/}
            {/*  <span className="statistics__comments mr-2"> { props.comments_count }</span>*/}
            {/*  <span className="statistics__views mr-2"> { props.views_count }</span>*/}
            {/*  <span className="statistics__mark mr-2"> { props.int_votes_score }</span>*/}
            {/*  <span className="statistics__payments mr-2"> { props.pay_count }</span>*/}
            {/*</span>*/}
          </div>
          { !props.notShowPrice && <div className="card-price d-inline-block mt-2 mb-3">{ price }</div> }
          { props.children }
        </div>
      </div>
    </div>
  </div>
};

ShopOfferItem.propTypes = {
  discount: PropTypes.number.isRequired,
  price_format: PropTypes.string.isRequired,
  discount_price: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  type_icon: PropTypes.string.isRequired,
  type_name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  author_url: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  difficulty_display: PropTypes.string.isRequired,
  tonality_display: PropTypes.string,
  date_format: PropTypes.string.isRequired,
  comments_count: PropTypes.number.isRequired,
  views_count: PropTypes.number.isRequired,
  int_votes_score: PropTypes.number.isRequired,
  pay_count: PropTypes.number.isRequired,
  notShowPrice: PropTypes.bool,

  imageBlock: PropTypes.elementType,
  checkboxBlock: PropTypes.elementType,
  dropdownMenu: PropTypes.elementType,
}

export default ShopOfferItem;

